import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import { Button, Typography } from '@mui/material';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';
import PortalUser from '~common/lib/portal-user-context';
import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';
import * as request from 'superagent';
import ConfirmActionModal from "./user-query-view-confirm-action-modal"
import Renderers from '~common/lib/renderers';

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    // display: 'flex',
    // flexWrap: 'wrap',
    // justifyContent: 'space-around',
    overflow: 'hidden'
  },
  buttonBar: {
    display: "flex",
    flexDirection:"row-reverse",
    justifyContent: "space-between",
    spaceBetween: 15,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready';
  error?: any;
  confirmPasswordResetUser?: any;
  confirmRemoveMFAUser?: any;
};

class UserAdminQueryList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
    };
  }

 componentDidMount() {
    // console.log("Into TSX")
  }

  removeMFA = () => {
    const {confirmRemoveMFAUser} = this.state
    request.put(`/api/auth/users/remove-mfa/${confirmRemoveMFAUser.id}`)
      .then((response:any)=>{
        window.location.reload()
      }).catch((err)=>{
        this.handleAPIError(err)
      })
  }

  resetPassword = () => {
    const {confirmPasswordResetUser} = this.state
    fetch(
      `/api/portal-users/password-reset/${confirmPasswordResetUser.id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response)=>{
      window.location.reload()
    }).catch((err)=>{
      this.handleAPIError(err)
    })
  }

  cancelRemoveMFA = () => {
    this.setState({confirmRemoveMFAUser: undefined })
  }

  cancelPasswordReset = () => {
    this.setState({confirmPasswordResetUser: undefined })
  }

  handleAPIError = (err:any)=> {
    this.setState({error: err})
  }

  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>()
    
    var self = this

    if (PortalUser.hasOneOfFeatures(['mfa_admin_account_recovery']) && row.mfaEnabled == true){
      actions.push({
        label: `Remove MFA`,
        onClick: () => {
          self.setState({confirmRemoveMFAUser: row})
        }
      })
    }

    if ((PortalUser.hasOneOfFeatures(['force_password_reset']) && !(row.extendedAttributes || {samlNameID:null}).samlNameID)) {
      actions.push({
        label: "Force Password Reset",
        onClick: () => {
          self.setState({confirmPasswordResetUser: row})
        },
      });
    }
  
    return actions
  }

  handleRowClick = (item) => {
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/users/admin/${item.id}?q=${URLManager.getQueryStringValue(criteria)}`
  }

  
  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status, confirmRemoveMFAUser, confirmPasswordResetUser} = this.state;
    
    var criteriaSelector = {
      "app": "admin",
      "form": "userSearchCriteria"
    }

    criteriaSelector["userType"] = portalUserContext.userType
    if (criteriaSelector["userType"] == "Portal Admin") {
      criteriaSelector["userType"] = "Internal"
    }

    var confirmModal: any;
    if (confirmRemoveMFAUser) {
          confirmModal = (
              <ConfirmActionModal
                user={confirmRemoveMFAUser}
                title={"Confirm MFA Removal"}
                confirmMessage={"Are you sure want remove multi-factor authentication for this user?"}
                open={true}
                handleYes={this.removeMFA}
                handleNo={this.cancelRemoveMFA}
          />
          )
    }

    if (confirmPasswordResetUser) {
      confirmModal = (
          <ConfirmActionModal
            user={confirmPasswordResetUser}
            title={"Confirm Password Reset"}
            confirmMessage={"Are you sure want reset the password for this user?"}
            open={true}
            handleYes={this.resetPassword}
            handleNo={this.cancelPasswordReset}
      />
      )
}

    switch (status) {
      case 'loading':
        return (
            <div className={classes.container}>
              <LoadingView classes={
                {}
              } />
            </div>
        );
      default:
        return (
            <div className={classes.container}>
              {confirmModal}
                <QueryList
                history={this.props.history}
                  criteriaFormSelector={criteriaSelector}
                  resultsFormSelector={
                    {
                      "app":"admin",
                      "form":"userSearchResults"
                    }
                  }
                  queryUrl="/api/user-search/query"
                  autoQuery={true}
                  forceExecuteOnLoad={false}
                  supressSectionStatusIcon
                  actionsForItemRow={this.handleActionsForItemRow}
                  reserveRowActionSpace={true}
                  onRowClick={this.handleRowClick}
                  alwaysExecuteOnSubmit={true}
                  customRenderers={{}}
                  submitButtonText={"Search"}
                  customSectionRenderer={}
                  // excludeFromClear={["supplierID","vendorNbrs"]}
                  noResultsText="No Results Found"
              >
              </QueryList>
            </div>
        );
    }
  }
}

export default withStyles(styles)(UserAdminQueryList);



